// src/dev/mockTeamIds.ts
//
// The mock team ids, alone in their own module because both sides of the fixture need them and they
// cannot import each other: mockTeams builds its roster from mockPipeline's MOCK_AUTH_USER, while
// mockPipeline stamps a team_id onto every project it fabricates.
//
// One id per role the mock user holds — owner of their own, member of one, admin of another — which is
// what makes the team-scoped surfaces (projects filter, Team tab, credits) show more than one state.

export const MOCK_TEAM_IDS = {
  own: 'team-dev-own',
  admin: 'team-northwind',
  member: 'team-acme',
} as const
